import client, { PUBLIC_CLIENT, PRIVATE_CLIENT } from '../../services/client';
import authStore from '../../store/auth';
import sessionStore from '../../store/session';
export const getOtp = async (mobile, scheme = "SMS") => {
    return await client.post('login/', PUBLIC_CLIENT, {
        mobile,
        scheme
    });
};
export const logout = async () => {
    const response = await client.post('auth/logout/', PRIVATE_CLIENT);
    authStore.logout();
    sessionStore.logout();
    // userStore.logout();
    return response;
};
export const verifyOtp = async (mobile, token) => {
    return await client.post('auth/token/', PUBLIC_CLIENT, {
        mobile,
        token,
    });
};
export const refreshToken = async () => {
    try {
        const response = await client.post(`auth/token/refresh/`, PUBLIC_CLIENT);
        authStore.login(response);
        return response;
    }
    catch (_) { }
};
